import React, { useEffect, useState, useRef, useCallback } from "react";
import nodata from "../../assets/img/no-data.svg";
import { TicketDetails, TicketReply, uploadImage } from "../../api/apiService";
import { useToken } from "../../components/TokenContext";
import { useLocation, Link } from "react-router-dom";
import UserIcon from "../../assets/img/user.svg";






const Help = () => {
  const [loading, setLoading] = useState(false);
  const { token, fetchToken } = useToken();
  const [tableData, setTableData] = useState([]);
  const [reactalert, setAlert] = useState({ type: "", message: "" });
  const [messages, setMessages] = useState([]);
  const [images, setImages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [newImage, setNewImage] = useState(null);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tid = params.get("tid"); // Ticket ID from URL
  const messagesEndRef = useRef(null);

  // ✅ Fetch Ticket Conversation (Fixed for ProductList)
  const fetchTicketHistory = useCallback(async () => {
    if (!tid) return;
    setLoading(true);
    try {
      let currentToken = token || (await fetchToken());
      if (!currentToken) return;

      const loginToken = localStorage.getItem("LoginToken") || currentToken;
      const response = await TicketDetails(currentToken, loginToken, tid);

      if (response.status) {
        // Ticket info (header)
        const ticketInfo = response.DataList?.[0] || {};
        setTableData(ticketInfo);

        // ✅ Chat messages are inside ProductList
        const messageList = response.ProductList || [];

        const formattedMessages = messageList.map((item) => {
          // Fix date format: replace double spaces and ensure readable fallback
          const rawDate = item.DATE ? item.DATE.replace(/\s+/g, " ").trim() : "";
          let formattedTime = rawDate;
          try {
            const parsedDate = new Date(rawDate);
            if (!isNaN(parsedDate)) {
              formattedTime = parsedDate.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              });
            }
          } catch {
            formattedTime = rawDate;
          }

          return {
            sender:
              item.FROMTYPE?.toLowerCase() === "me" ||
                item.FROMTYPE?.toLowerCase() === "user"
                ? "user"
                : "admin",
            text: item.MESSAGE || "",
            image: item.IMAGEURL || "",
            time: formattedTime,
            avatar:
              item.FROMTYPE?.toLowerCase() === "me" ||
                item.FROMTYPE?.toLowerCase() === "user"
                ? "https://takshitsolutions.com/img/our-process-crm.svg"
                : "https://takshitsolutions.com/img/our-process-crypto-icon.svg",
          };
        });

        setMessages(formattedMessages);
      } else {
        setTableData([]);
        setMessages([]);
      }
    } catch (error) {
      console.error("Error loading ticket history:", error);
      setMessages([]);
    } finally {
      setLoading(false);
    }
  }, [token, fetchToken, tid]);



  // ✅ On Mount & When Ticket ID Changes
  useEffect(() => {
    fetchTicketHistory();
  }, [fetchTicketHistory]);

  // ✅ Handle Sending Message
  const handleSend = async () => {
    if (!newMessage.trim() && images.length === 0) {
      setAlert({ type: "error", message: "Please enter a message or attach an image." });
      return;
    }

    let currentToken = token;
    if (!currentToken) {
      currentToken = await fetchToken();
      if (!currentToken) return;
    }

    try {
      const loginToken = localStorage.getItem("LoginToken");
      if (!loginToken) {
        setAlert({ type: "error", message: "Session expired. Please login again." });
        return;
      }

      const imageUrls = images.map((img) => img.url).join(",");
      const data = await TicketReply(currentToken, newMessage, imageUrls, tid);

      if (data?.data === "success") {
        setAlert({ type: "success", message: "Message sent successfully!" });
        setNewMessage("");
        setImages([]);
        fetchTicketHistory(); // Refresh chat
      } else {
        setAlert({ type: "error", message: data?.data || "Failed to send message!" });
      }
    } catch (err) {
      console.error("Error sending ticket reply:", err);
      setAlert({ type: "error", message: "Something went wrong while sending message." });
    }
  };

  // ✅ Send on Enter Key
  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSend();
  };

  // ✅ File Upload + Preview
  const handleFileChange = async (files) => {
    const newFiles = Array.from(files);
    for (let file of newFiles) {
      try {
        const previewUrl = URL.createObjectURL(file);

        let currentToken = token || (await fetchToken());
        if (!currentToken) return;

        const result = await uploadImage(currentToken, file);
        if (result?.status) {
          setImages((prev) => [
            ...prev,
            { preview: previewUrl, url: result.data },
          ]);
        } else {
          console.error("Upload failed:", result?.error || result?.message);
        }
      } catch (err) {
        console.error("File upload error:", err);
      }
    }
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  // ✅ Auto Scroll on New Message
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="buyshheikh-page">
      <div className="row">
        <div className="col-md-9">
          <div className="pageTitle d-flex justify-content-between align-items">
            <span>🎫 Support Ticket</span>
            <Link to={`/help/tickets`} className="text-warning">
              <i className="fa-solid fa-clock-rotate-left"></i>
            </Link>
          </div>

          <div className="card mb-3">
            <div className="card-body">
              <div className="chat-container">
                {/* Header */}
                <div className="chat-header">
                  <div className="user-info">
                    <div className="user-wrp-dv">
                      <span className="use-name-sd">
                        <img
                          src="https://takshitsolutions.com/img/our-process-crypto-icon.svg"
                          alt="Admin"
                          className="user-img"
                        />
                      </span>
                      <h5>Ticket ID: {tableData.TICKETNO}</h5>

                    </div>
                    <span>{tableData.LASTUPDATE}</span>
                  </div>
                </div>

                {/* Messages */}
                <div className="chat-messages">
                  {loading ? (
                    <div className="text-center text-muted p-3">Loading...</div>
                  ) : messages.length === 0 ? (
                    <div className="empty-state">
                      <img src={nodata} alt="No Data" width="120" />
                      <p>No messages yet. Start the conversation!</p>
                    </div>
                  ) : (
                    messages.map((msg, idx) => (
                      <div
                        key={idx}
                        className={`message ${msg.sender === "user" ? "user-msg" : "admin-msg"
                          }`}
                      >
                        <div className="user-img-div">
                          {/* <img
                            src={
                              msg.sender === "user"
                                ? "https://takshitsolutions.com/img/our-process-crm.svg"
                                : "https://takshitsolutions.com/img/our-process-crypto-icon.svg"
                            }
                            className="user-img"
                            alt="User"
                          /> */}

                          <img
                            src={UserIcon}
                            className="user-img"
                            alt="App Icon"
                          />
 

                        </div>

                        <div className="user-img-txt">
                          <span>{msg.text}</span>
                          {msg.image && (
                            <img src={msg.image} alt="attachment" className="chat-img" />
                          )}
                          <span className="message-time">
                            <i className="fa-regular fa-clock"></i> {msg.time}
                          </span>
                        </div>
                      </div>
                    ))
                  )}
                  <div ref={messagesEndRef} />
                </div>

                {/* Input */}
                <div className="chat-input">
                  <input
                    type="text"
                    placeholder="Type your message..."
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    onKeyDown={handleKeyPress}
                  />
                  <input
                    type="file"
                    id="fileUpload"
                    multiple
                    accept="image/*"
                    onChange={(e) => handleFileChange(e.target.files)}
                    className="d-none"
                  />
                  <label htmlFor="fileUpload" className="upload-label">
                    📎
                  </label>
                  <button onClick={handleSend}>Send</button>
                </div>

                {/* Image Preview */}
                {images.length > 0 && (
                  <div className="image-preview-grid mt-3">
                    {images.map((img, index) => (
                      <div key={index} className="preview-card">
                        <img src={img.preview} alt="preview" />
                        <button
                          type="button"
                          className="remove-btn"
                          onClick={() => removeImage(index)}
                        >
                          <i className="fa fa-times"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
